<template>
  <template v-if="hasActive">
    <div class="gmf-subheader" v-text="t('quests.list_header.active')" />
    <div class="gmf-text-small gmf-mb-5" v-text="t('quests.list_ingress.active')"></div>
    <div class="gmf-quest-list">

      <template v-for="pool in pools" :key="pool.id">
        <div v-if="pool.incomplete.length">
          <VerticalSeparator v-if="pool.name">
            {{ pool.name }}
          </VerticalSeparator>
          <Quest :quest="quest" v-for="quest in pool.incomplete" :key="quest.id" />
        </div>
      </template>
    </div>

  </template>
  <template v-if="hasComplete">
    <div class="gmf-subheader" v-text="t('quests.list_header.complete')" />
    <div class="gmf-quest-list">

      <template v-for="pool in pools" :key="pool.id">
        <div v-if="pool.complete.length">
          <VerticalSeparator v-if="pool.name">
            {{ pool.name }}
          </VerticalSeparator>
          <Quest :quest="quest" v-for="quest in pool.complete" :key="quest.id" :showRewards="false" />
        </div>
      </template>
    </div>
  </template>

</template>

<style>
.gmf-quest-list {
  display: flex;
  flex-direction: column;
  gap: var(--gmf-p-5);
}

.gmf-context .gmf-quest-list > .gmf-subheader {
  margin-bottom: calc(0px - var(--gmf-p-4));
}
.gmf-quest-list .gmf-vertical-separator {
  margin-bottom: var(--gmf-p-3);
}

.gmf-quest-list .gmf-quest + .gmf-quest {
    margin-top: var(--gmf-p-3);
}
</style>

<script>
import callApi from '@/utils/callApi';
import Quest from './Quest';
import state from '@/state';
import VerticalSeparator from '@/components/VerticalSeparator';
const t = state.t;

async function loadQuests () {
  const listRes = await callApi('GET', '/v1/client/quests');
  const { quests } = await listRes.json();
  return quests;
}

export default {
  components: {
    Quest,
    VerticalSeparator,
  },
  inject: {
    modalState: {
      default: null,
    },
  },
  created () {
    this.load();
  },
  data () {
    return {
      quests: [],
    };
  },
  computed: {
    unlockedQuestMap () {
      const map = {};
      for (const quest of this.quests) {
        if (quest.achievedAt) {
          map[quest.id] = quest;
        }
      }
      return map;
    },
    hasActive () {
      for (const pool of this.pools) {
        if (pool.incomplete.length) {
          return true;
        }
      }
      return false;
    },
    hasComplete () {
      for (const pool of this.pools) {
        if (pool.complete.length) {
          return true;
        }
      }
      return false;
    },
    pools () {
      const poolMap = {};
      const pools = [];
      for (const quest of this.questsToShow) {
        if (! poolMap[quest.questPool.id]) {
          const pool = {
            id: quest.questPool.id,
            name: quest.questPool.name,
            complete: [],
            incomplete: [],
          };
          poolMap[quest.questPool.id] = pool;
          pools.push(pool);
        }
        if (quest.achievedAt) {
          poolMap[quest.questPool.id].complete.unshift(quest);
        } else {
          poolMap[quest.questPool.id].incomplete.unshift(quest);
        }
      }
      return pools;
    },
    questsToShow () {
      const unlocked = this.unlockedQuestMap;
      return this.quests.filter(quest => {
        /*
        if (quest.achievedAt && quest.lastShownProgress >= 100) {
          return false;
        }
        */

        if (quest.parentId && ! unlocked[quest.parentId]) {
          return false;
        }

        return true;
      });
    },
  },
  watch: {
    'modalState.isTopModal' (isTop) {
      // Reload when coming back from another modal
      if (isTop) {
        this.load();
      }
    },
  },
  methods: {
    t,
    async load () {
      this.quests = await loadQuests();
    },
  },
};

</script>
